import React from "react";
import { UserDetails } from "../../_metronic/_partials";

export function UserDetailsPage(props) {
  return <UserDetails />;
}
